import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import toastr from "toastr";
import startCase from "lodash/startCase";
import { APP_URL, currency, ERMC_API_KEY } from "../../helpers/constants";
import {
  bookBetCall,
  getCashBalanceLogs,
  getRegulatoryAndParameters,
  getUserInfo,
  placeBetCall,
  axiosApi,
  placeSingleBetCall,
  getMyBetsData,
  BlockedGames,
  confirmCashout,
} from "../../helpers/repository";
import { setBets } from "../../store/Betslip/actions";
import { useHistory, useLocation } from "react-router-dom";
import { formatValue } from "../../helpers/utils";
import clsx from "clsx";
import { getfreebetAmount, getUserBalance } from "./Utils/helpers";
import { showMessage } from "./Toaster";
import ReactModal from "react-modal";
import { isEmpty } from 'lodash';
import { Twitter, Facebook, Whatsapp, Telegram } from "react-social-sharing";
import OpenBets from "../../pages/MyBets/OpenBets";
import MessageBox from "./MessageBox";
import { Loader2, Receipt, Trash2, X } from "lucide-react";
import { EmptyState } from "../ui/empty-state";
import { motion } from "framer-motion";
import { Tabs, TabsList, TabsTrigger } from "../ui/tabs";
import { Trans, useTranslation } from "react-i18next";
import i18n from "../../i18n";

const BetSlipWidget = (props) => {
  const { t } = useTranslation();
  let history = useHistory();
  // Use the router's own location rather than props.location: this widget is
  // rendered as a plain <BetSlipWidget /> (no props) from AppLayout, so
  // props.location was always undefined and a ?booking_code= in the URL
  // never actually reached this component.
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const booking_code = query.get("booking_code");

  const [tab, setTab] = useState("betslip");
  const [mode, setMode] = useState("multiple");
  const [singleStakes, setSingleStakes] = useState({});
  const [country, setCountry] = useState("International");
  const [bookingCode, setBookingCode] = useState("");
  const [myBets, setMyBets] = useState([]);
  const [category, set_category] = useState("Sports");
  const [loadingMessage, setLoadingMessage] = useState(t("betslip_loading_data", "Loading Data..."));
  const [acceptOddsChange, setAcceptOddsChange] = useState(false);
  const [keepBet, setKeepBet] = useState(false);
  const [stakeAmount, setStakeAmount] = useState(100);
  const [note, setNote] = useState("");
  const [totalOddNew, setTotalOddNew] = useState(0);
  const [oldStake, setOldStake] = useState(0);
  const [stake, setStake] = useState(100);
  const [exciseTax, setExciseTax] = useState(0);
  const [WHT, setWHT] = useState(0);
  const [firstDeposit, setFirstDeposit] = useState(0);
  const [bonusAmount, setBonusAmount] = useState(0);
  const [WIN, setWIN] = useState(0);
  const [multiBonusPercent, setMultiBonusPercent] = useState(0);
  const [odds, setOdds] = useState(null);
  const [openModel, setModelOpen] = useState(false);
  const [openBookModel, setBookModelOpen] = useState(false);
  const [loading, setLoading] = useState(null);
  const [loadingBook, setloadingBook] = useState(null);
  const [minimumOdds, setMinimumOdds] = useState(null);
  const [isBonusActive, setIsBonusActive] = useState(0);
  const [bonusPercentage, setBonusPercentage] = useState(null);
  const [minMatch, setMinMatch] = useState(1);
  const [signupBonus, setSignupBonus] = useState(0)
  const [multiBonusAmount, setMultiBonusAmount] = useState(0);
  const [bonusMinimumOdds, setBonusMinimumOdds] = useState(null);
  const [cashLogStatus, setCashLogStatus] = useState(false);
  const [minimumBet, setMinimumBet] = useState(null);
  const [maximumBet, setMaximumBet] = useState(null);
  const [freebetMinimumOdds, setFreebetMinimumOdds] = useState(null)
  const [freebetMaximumOdds, setFreebetMaximumOdds] = useState(null)
  const [freebetMinimumMatches, setFreebetMinimumMatches] = useState(null)
  const [exciseTaxPercentage, setExciseTaxPercentage] = useState(null);
  const [WHTPercentage, setWHTPercentage] = useState(null);
  const [maximumPayout, setMaximumPayout] = useState(null);
  const [maximumBonusPayout, setMaximumBonusPayout] = useState(null);
  const [selectedPercent, setSelectedPercent] = useState(0);
  const [useBonus, setUseBonus] = useState(false);
  const [canUseBonus, setCanUseBonus] = useState(false);
  const [totalOdds, setTotalOdds] = useState(0);
  const [selectedBonus, setSelectedBonus] = useState(0);
  const [bookingId, setBookingId] = useState(booking_code);
  const [isAllPrematch, setIsAllPrematch] = useState(false);
  const [addMoreCount, setAddMoreCount] = useState(null);
  const [bonusPercent, setBonusPercent] = useState(null);
  const [notApplicableOdds, setNotApplicableOdds] = useState(0);
  const [userBalance, setUserBalance] = useState(0);
  const [isBalanceLess, setIsBalanceLess] = useState(false);
  const [bonusError, setBonusError] = useState("");
  const [bonusType, setBonusType] = useState('')

  const [searchBookingCode, setSearchBookingCode] = useState(booking_code);
  const [checkLiveSelected, setcheckLiveSelected] = useState(true);
  const [freebet, setfreebet] = useState(0);
  const [showFreebetMsg, setshowFreebetMsg] = useState(false);
  const [useFreeBet, setuseFreeBet] = useState(false);
  const [sortCategory, set_sort_category] = useState('Latest');
  const [myBetsOpen, setMyBetsOpen] = useState([]);

  const [isCashout, setIsCashout] = useState(false);
  const [ticketDetails, setTicketDetails] = useState(null);
  const [isLoadingId, setIsLoadingId] = useState(false);
  const [confirmCashoutLoading, setConfirmCashoutLoading] = useState(false);


  const Bets = useSelector((state) => state?.Betslip?.bets ?? []);
  let dispatch = useDispatch();
  const isLoggedIn = sessionStorage.getItem("token") ? true : false;

  const copied = () => {
    navigator.clipboard.writeText(bookingId);
    $(".apply-p1")
      .empty()
      .show()
      .text(t("betslip_copied", "Copied"))
      .css({
        color: "white",
        "background-color": "#272727",
        "text-align": "center",
        "border-radius": "2px",
        width: "max-content",
        position: "absolute",
        "z-index": "1",
        padding: "8px 9px 8px 12px",
        margin: "-9px 0px 0px 5px",
        fontSize: "10px",
      })
      .delay(2000)
      .fadeOut(300);
  };

  const bburl = `${APP_URL}/betSlip?booking_code=${bookingId}`;

  const CountDown = ({ hours = 0, minutes = 0, seconds = 0 }) => {
    const [over, setOver] = useState(false);
    const [[h, m, s], setTime] = useState([hours, minutes, seconds]);

    const tick = () => {
      if (over) return;
      if (h === 0 && m === 0 && s === 0) {
        setOver(true);
        setModelOpen(false);
        setLoading(0);
        setloadingBook(0);
      } else if (m === 0 && s === 0) {
        setTime([h - 1, 59, 59]);
      } else if (s == 0) {
        setTime([h, m - 1, 59]);
      } else {
        setTime([h, m, s - 1]);
      }
    };

    useEffect(() => {
      const timerID = setInterval(() => tick(), 1000);
      return () => clearInterval(timerID);
    });

    return (
      <div style={{ "text-align": "center", "margin-top": "10px" }}>
        <h6 style={{ color: "#ff0000" }}>{`${h.toString().padStart(2, "0")}:${m
          .toString()
          .padStart(2, "0")}:${s.toString().padStart(2, "0")}`}</h6>
      </div>
    );
  };
  useEffect(() => {
    const storedBets = localStorage.getItem("betsplace");
    if (storedBets) {
      dispatch(setBets(JSON.parse(storedBets)));
    }
  }, [dispatch]);

  useEffect(() => {
    localStorage.setItem("betsplace", JSON.stringify(Bets));
    let BetOdd = Bets.map((bet) => {
      return _getPlacedBet(bet.fixture_markets);
    }).map((bet) => {
      let sendBet = {};
      sendBet._id = bet.is_special_market_odd ? bet.base_odd_id : bet._id;
      return sendBet;
    });
    const bookDetail = JSON.parse(localStorage.getItem("book_bet_detail"));
    if (BetOdd?.length == bookDetail?.odds?.length) {
      const obj1Ids = BetOdd.map((item) => item._id);
      const obj2Ids = bookDetail?.odds.map((item) => item._id);
      const areAllIdsSame =
        obj1Ids.every((id) => obj2Ids.includes(id)) &&
        obj2Ids.every((id) => obj1Ids.includes(id));
      if (areAllIdsSame) {
        setSearchBookingCode(bookDetail?.booking_id);
        setBookingId(bookDetail?.booking_id);
      }
    } else {
      setSearchBookingCode(null);
      setBookingId(null);
    }
  }, [Bets]);

  useEffect(() => {
    if (freebet > 0) {
      if (parseFloat(stake) == freebet) {
        setshowFreebetMsg(false);
        setuseFreeBet(true);
      } else {
        setshowFreebetMsg(true);
        setuseFreeBet(false);
      }
    }
  }, [stake]);

  useEffect(() => {
    if (booking_code) {
      setBookingId(booking_code);
    } else {
      const bookDetail = JSON.parse(localStorage.getItem('book_bet_detail'));
      if (bookDetail?.booking_id) {
        setBookingId(bookDetail.booking_id);
      }
    }
  }, [openBookModel]);

  useEffect(() => {
    getRegulatoryAndParameters(handleSuccess);
    if (isLoggedIn) {
      getCashBalanceLogs(handleEndUserLogSuccess);
      getUserInfo(handleSuccessGotUser, errorUserInfoCall);
      setUserBalance(getUserBalance());
      setfreebet(getfreebetAmount());
    }
  }, []);

  const errorUserInfoCall = (e) => {
    showMessage(e);
  };

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "50%",
    },
  };
  const customBetStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "50%",
      backgroundColor: "#272727",
      color: "white",
      padding: "0px",
    },
  };

  useEffect(() => {
    if (!isEmpty(tab) && isLoggedIn) {
      setLoadingMessage(i18n.t("betslip_loading_data", "Loading Data..."));
      getMyBetsData(
        category,
        'Open',
        successGetMyBets,
        errorGetMyBets,
        sortCategory
      );
    }
  }, [category, tab, sortCategory, isLoggedIn]);

  const successGetMyBets = (data) => {
    if (data?.length == 0) setLoadingMessage(i18n.t("betslip_no_data_available", "No Data Available"));
    setMyBetsOpen(data);
  };

  const errorGetMyBets = (error) => {
    showMessage('error', error);
  };

  useEffect(() => {
    if (myBetsOpen.length > 0) {
      setLoadingMessage(null);
    } else {
      setLoadingMessage(t("betslip_no_data_available", "No Data Available"));
    }

    BlockedGames()
      .then((res) => {
        setIframeURL(res);
      })
      .catch((e) => {
        if (e?.response?.data?.code == 'restrict') {
          setShow(true);
          // props.history.push("/comming-soon");
        }
      });
  }, [myBetsOpen, t]);

  const _handleSubmitBet = () => {
    setLoading(1);
    if (!isLoggedIn) {
      history.push(`/login`);
      return;
    }
    if (parseFloat(stake) < minimumBet) {
      toastr.error(t("betslip_stake_min_limit", "Stake should be Greater Or Equal to {value}", { value: minimumBet }));
      return;
    } else if (parseFloat(stake) > maximumBet) {
      toastr.error(t("betslip_stake_max_limit", "Stake should be Less Or Equal to {value}", { value: maximumBet }));
      return;
    }
    var live_array = [];
    let odds = Bets.map((bet) => {
      return _getPlacedBet(bet.fixture_markets);
    }).map((bet) => {
      // let sendBet = {};
      // sendBet._id = bet._id;
      // sendBet.value = parseFloat(bet.value);
      // sendBet.base_line = bet.special_bet_value;
      // if (bet.is_live === 1) {
      //   sendBet.is_live = 1;
      // }
      /* 1UP/2UP synthetic odds: backend expects the BASE odd's _id (so it
         can link the leg via special_market_id) but the SPECIAL/boosted
         odd as `value` — the special odd is what actually gets recorded
         and settled, not the base price. bet.value already holds the
         boosted price for special bets, so no branching is needed here. */
      const sendBet = {
        _id: bet.is_special_market_odd ? bet.base_odd_id : bet._id,
        value: parseFloat(bet.value),
        base_line: bet.special_bet_value,
        ...(bet.is_special_market_odd && {
          market_type: "special",
          special_market_id: bet.special_market_id,
        }),
        ...(bet.is_live === true && { is_live: 1 }),
      };

      if (typeof bet.is_live === "undefined") {
        live_array.push(null);
      } else {
        live_array.push(bet.is_live);
      }
      return sendBet;
    });


    if (useFreeBet) {
      const minimumMatch = Number(freebetMinimumMatches);
      const minOdds = Number(freebetMinimumOdds);
      const maxOdds = Number(freebetMaximumOdds);

      const hasFewSelections = Bets.length < minimumMatch;
      const numericTotalOdds = Number(totalOdds);

      // Validation 1 – minimum selections
      if (hasFewSelections) {
        setBonusError(t("betslip_freebet_min_selections", "Add at least {value} selections to use Free Bet.", { value: minimumMatch }));
        return;
      }

      // Validation 2 – total odds range check
      if (numericTotalOdds < minOdds || numericTotalOdds > maxOdds) {
        setBonusError(
          t("betslip_freebet_odds_range", "Total odds must be between {min} and {max} to use Free Bet.", { min: minOdds, max: maxOdds })
        );
        return;
      }
    }



    // if (useFreeBet) {
    //   const minimumMatch = parseInt(freebetMinimumMatches, 10);
    //   const minOdds = parseFloat(freebetMinimumOdds);
    //   const maximumOdds = parseFloat(freebetMaximumOdds)

    //   const hasLowOdd = odds.some((o) => parseFloat(o.value) < minOdds);
    //   const hasFewSelections = Bets.length < minimumMatch;

    //   if (hasFewSelections) {
    //     setBonusError(`Add at least ${minimumMatch} selections to use Free Bet`);
    //     return;
    //   }

    //   if (hasLowOdd) {
    //     setBonusError(`Each selection must have odds of ${minOdds}+`);
    //     return;
    //   }
    // }


    // if (useFreeBet) {
    //   const hasLowOdd = odds.some((o) => parseFloat(o.value) < 2);
    //   if (Bets.length < 5 || hasLowOdd) {
    //     setBonusError(`Required: Min. selection ${minMatch} with ${bonusMinimumOdds}+ odds each`)
    //     return;
    //   }

    // }

    const allEqual = (arr) => arr.every((val) => val === arr[0]);
    // if (!allEqual(live_array)) {
    //   toastr.error(`Live and upcoming bets can’t be combined in one ticket. Please place them separately`);
    //   return;
    // }
    var toWin = _getPossibleWin();
    if (useBonus && parseFloat(toWin) > parseFloat(maximumBonusPayout)) {
      toastr.error(
        t("betslip_win_exceeds_bonus_max", "Win Amount Must be less than {value},please remove some of matches", { value: maximumBonusPayout })
      );
      return;
    } else if (parseFloat(toWin) > parseFloat(maximumPayout)) {
      toastr.error(
        t("betslip_win_exceeds_max", "Win Amount Must be less than {value},please remove some of matches", { value: maximumPayout })
      );
      return;
    }
    if (parseFloat(toWin) <= 0) {
      toastr.error(t("betslip_to_win_zero", "To Win should be greater than zero"));
      return;
    }
    if (parseFloat(stake) <= 0) {
      toastr.error(t("betslip_stake_zero", "Stake should be greater than zero"));
      return;
    }
    let data = {};
    data.odds = odds;
    data.stake = stake;
    data.accept_odds_change = acceptOddsChange;
    data.bonus_amount = selectedBonus != 0 && !useBonus ? selectedBonus : null;
    data.wht = _getPossibleWHT();
    data.to_win = _getPossibleWin();
    data.use_bonus = useBonus;
    data.percentageCurrent = selectedPercent;
    data.is_balance_less = isBalanceLess;
    data.minimum_odds = minimumOdds;
    data.booking_code = bookingId;
    data.minimum_odds = minimumOdds;
    data.booking_code = bookingId;
    data.useFreeBet = useFreeBet;
    if (allEqual(live_array)) {
      data.is_live = live_array[0] == null ? "0" : "1";
    }

    // data.
    if (mode === "multiple") {
      placeBetCall(data, handleSuccessPlaceBet, handleErrorPlaceBet);
    } else {
      placeSingleBetCall(data, handleSuccessPlaceBet, handleErrorPlaceBet);
    }
  };


  const _handleBookBet = () => {
    setloadingBook(1);
    if (parseFloat(stake) < minimumBet) {
      toastr.error(t("betslip_stake_min_limit", "Stake should be Greater Or Equal to {value}", { value: minimumBet }));
      return;
    } else if (parseFloat(stake) > maximumBet) {
      toastr.error(t("betslip_stake_max_limit", "Stake should be Less Or Equal to {value}", { value: maximumBet }));
      return;
    }
    var live_array = [];
    let odds = Bets.map((bet) => {
      return _getPlacedBet(bet.fixture_markets);
    }).map((bet) => {
      /* 1UP/2UP synthetic odds: backend expects the BASE odd's _id (so it
         can link the leg via special_market_id) but the SPECIAL/boosted
         odd as `value` — the special odd is what actually gets recorded
         and settled, not the base price. bet.value already holds the
         boosted price for special bets, so no branching is needed here. */
      const sendBet = {
        _id: bet.is_special_market_odd ? bet.base_odd_id : bet._id,
        value: parseFloat(bet.value),
        base_line: bet.special_bet_value,
        ...(bet.is_special_market_odd && {
          market_type: "special",
          special_market_id: bet.special_market_id,
        }),
        ...(bet.is_live === true && { is_live: 1 }),
      };
      if (typeof bet.is_live === "undefined") {
        live_array.push(null);
      } else {
        live_array.push(bet.is_live);
      }
      return sendBet;
    });

    const allEqual = (arr) => arr.every((val) => val === arr[0]);
    // if (!allEqual(live_array)) {
    //   toastr.error(`Live and upcoming bets can’t be combined in one ticket. Please place them separately`);
    //   return;
    // }
    var toWin = _getPossibleWin();
    if (useBonus && parseFloat(toWin) > parseFloat(maximumBonusPayout)) {
      toastr.error(
        t("betslip_win_exceeds_bonus_max", "Win Amount Must be less than {value},please remove some of matches", { value: maximumBonusPayout })
      );
      return;
    } else if (parseFloat(toWin) > parseFloat(maximumPayout)) {
      toastr.error(
        t("betslip_win_exceeds_max", "Win Amount Must be less than {value},please remove some of matches", { value: maximumPayout })
      );
      return;
    }
    if (parseFloat(toWin) <= 0) {
      toastr.error(t("betslip_to_win_zero", "To Win should be greater than zero"));
      return;
    }
    if (parseFloat(stake) <= 0) {
      toastr.error(t("betslip_stake_zero", "Stake should be greater than zero"));
      return;
    }

    let data = {};
    data.odds = odds;
    data.stake = stake;
    data.accept_odds_change = acceptOddsChange;
    data.bonus_amount = selectedBonus != 0 && !useBonus ? selectedBonus : null;
    data.wht = _getPossibleWHT();
    data.to_win = _getPossibleWin();
    data.use_bonus = useBonus;
    data.percentageCurrent = selectedPercent;
    data.is_balance_less = isBalanceLess;
    data.minimum_odds = minimumOdds;
    if (allEqual(live_array)) {
      data.is_live = live_array[0] == null ? "0" : "1";
    }

    // data.
    bookBetCall(data, handleSuccessBookBet, handleErrorBookBet);
  };

  const handleSuccessBookBet = (response) => {
    let res = response.data.data;
    setNote("");
    setModelOpen(false);

    if (res?.booking_id) {
      let bookDetail = {};
      bookDetail.booking_id = res?.booking_id;
      bookDetail.odds = res?.odds;
      localStorage.setItem("book_bet_detail", JSON.stringify(bookDetail));
    }

    if (res.is_difference) {
      let size = Object.keys(res.odds).length;

      if (!res.is_bonus_used && useBonus) {
        setNote(
          t("betslip_note_min_selection_odds", "Required: Min. selection {minMatch} with {minOdds}+ odds each", { minMatch, minOdds: bonusMinimumOdds })
        );
      } else if (
        res.bonus_amount &&
        parseFloat(res.bonus_amount) != parseFloat(selectedBonus)
      ) {
        setNote(t("betslip_note_required_odds", "Required: Selection with {value}+ odds", { value: minimumOdds }));
      } else if (size < Bets.length) {
        setNote(t("betslip_note_markets_closed", "Some matches or markets have closed"));
      }

      setOdds(res.odds);
      setTotalOddNew(res.total_odds);
      setStake(res.stake);
      setWHT(res.wht);
      setMultiBonusPercent(res.percentageCurrent);
      setMultiBonusAmount(res.bonus_amount ? res.bonus_amount : 0);
      setWIN(res.to_win);

      let data = {};
      data.odds = res.odds;
      data.stake = res.stake;
      data.accept_odds_change = res.accept_odds_change;
      data.is_live = res.is_live;
      data.bonus_amount = res.bonus_amount;
      data.wht = res.wht;
      data.to_win = res.to_win;
      data.use_bonus = res.is_bonus_used ? true : false;
      data.percentageCurrent = res.percentageCurrent;
      data.is_balance_less = res.is_balance_less;
      data.minimum_odds = res.minimum_odds;
    } else {
      if (!keepBet) {
        dispatch(setBets([]));
      }
      setCanUseBonus(false);
      setUseBonus(false);
      setBonusAmount(0); //once they use bonus whole bonus balance will be used
      setloadingBook(0);
      setBookModelOpen(true);
      setBookingId(res?.booking_id);
      toastr.success(t("betslip_book_success", "Bet Book Successfully"));
    }
  };

  const handleSuccessPlaceBet = (response) => {
    let res = response.data.data ? response.data.data : response.data.success;

    setNote("");
    setModelOpen(false);
    if (response?.data?.error_code == "selection") {
      res?.map((oddsData) => {
        $('[data-id="' + oddsData + '"]').addClass("highlightRemoveClass");
      });
      toastr.error(t("betslip_markets_closed_remove", "These markets are closed, please remove"));
      return;
    }

    if (res.is_difference) {
      let size = Object.keys(res.odds).length;

      if (!res.is_signup_freebet_used && useFreeBet) {
        setNote(
          t("betslip_note_min_selection_odds", "Required: Min. selection {minMatch} with {minOdds}+ odds each", { minMatch, minOdds: bonusMinimumOdds })
        );
      } else if (!res.is_bonus_used && useBonus) {
        setNote(
          t("betslip_note_min_selection_odds", "Required: Min. selection {minMatch} with {minOdds}+ odds each", { minMatch, minOdds: bonusMinimumOdds })
        );
      } else if (
        res.bonus_amount &&
        parseFloat(res.bonus_amount) != parseFloat(selectedBonus)
      ) {
        setNote(t("betslip_note_required_odds", "Required: Selection with {value}+ odds", { value: minimumOdds }));
      } else if (size < Bets.length) {
        setNote(t("betslip_note_markets_closed", "Some matches or markets have closed"));
      }

      setOdds(res.odds);
      setTotalOddNew(res.total_odds);
      setStake(res.stake);
      setWHT(res.wht);
      setMultiBonusPercent(res.percentageCurrent);
      setMultiBonusAmount(res.bonus_amount ? res.bonus_amount : 0);
      setWIN(res.to_win);

      localStorage.removeItem("store_data");

      let data = {};
      data.odds = res.odds;
      data.stake = res.stake;
      data.accept_odds_change = res.accept_odds_change;
      data.is_live = res.is_live;
      data.bonus_amount = res.bonus_amount;
      data.wht = res.wht;
      data.to_win = res.to_win;
      data.use_bonus = res.is_bonus_used ? true : false;
      data.useFreeBet = res.is_signup_freebet_used ? true : false;
      data.percentageCurrent = res.percentageCurrent;
      data.is_balance_less = res.is_balance_less;
      data.minimum_odds = res.minimum_odds;

      localStorage.setItem("store_data", JSON.stringify(data));
      setModelOpen(true);
    } else {
      if (!keepBet) {
        dispatch(setBets([]));
      }
      setCanUseBonus(false);
      setUseBonus(false);
      bonusType ? setBonusAmount(0) : setSignupBonus(0); setLoading(0);
      setLoading(0);
      setshowFreebetMsg(false);
      toastr.success(t("betslip_place_success", "Bet Placed Successfully"));

      const event = Array.isArray(res) ? res : [res];

      event.forEach((e) => {
        LocationSDK.reportBetEvent({
          apiKey: ERMC_API_KEY,
          eventDetails: {
            bet_id: String(e.id),
            user_id: String(e.user_id),
            stake_amount: Number(e.stake),
            odds: parseFloat(e.total_odds),
            expected_payout: parseFloat(e.to_win),
          },
          environment: "production"
        })
      })
    }
    localStorage.removeItem("book_bet_detail");
  };

  const handleErrorPlaceBet = (error) => {
    setNote("");
    setModelOpen(false);
    setLoading(0);
    toastr.error(error);
  };

  const handleErrorBookBet = (error) => {
    setNote("");
    setModelOpen(false);
    setloadingBook(0);
    toastr.error(error);
  };

  const _getPlacedBet = (markets) => {
    for (let i = 0; i < markets.length; i++) {
      let odds = markets[i].fixture_market_odds.filter((o) => o?.selected);
      if (odds.length) {
        return odds[0];
      }
    }
  };

  const _getMarketName = (markets) => {
    for (let i = 0; i < markets.length; i++) {
      let odds = markets[i].fixture_market_odds.filter((o) => o?.selected);
      if (odds.length) {
        const fm = markets[i];
        const specialLabel = fm.is_special_market
          ? fm.special_market_name === "one_up"
            ? ` - ${t("betslip_market_1up", "1UP")}`
            : fm.special_market_name === "two_up"
              ? ` - ${t("betslip_market_2up", "2UP")}`
              : ` - ${fm.special_market_name}`
          : "";
        return fm.market.name + specialLabel;
      }
    }
  };

  const _renderOddName = (f, odd) => {
    if (odd?.player) {
      return odd?.player?.name;
    }
    let text = odd?.market_spec?.name;
    text = text?.replaceAll("{$competitor1}", f?.competitors[0]?.name);
    text = text?.replaceAll("{$competitor2}", f?.competitors[1]?.name);
    return startCase(text);
  };

  function getKeyByValue(object, value) {
    return Object.keys(object).find((key) => object[key]["_id"] === value);
  }

  const _submitBet = () => {
    setLoading(1);
    let data = JSON.parse(localStorage.getItem("store_data"));
    localStorage.removeItem("store_data"); //for reducing multiple call
    if (mode === "multiple") {
      placeBetCall(data, handleSuccessPlaceBet, handleErrorPlaceBet);
    } else {
      placeSingleBetCall(data, handleSuccessPlaceBet, handleErrorPlaceBet);
    }
  };

  const handleSuccessGotUser = (res) => {
    setFirstDeposit(res?.data?.first_deposit);
    setBonusAmount(res?.data?.bonus_balance);
    setSignupBonus(res?.data.signup_freebet)
  };

  const handleEndUserLogSuccess = (res) => {
    setCashLogStatus(res?.status);
  };

  const handleSuccess = (res) => {
    setMinimumOdds(res?.betting_limits?.minimum_odds);
    setIsBonusActive(res?.betting_limits?.is_bonus_active);
    setBonusPercentage(res.multi_bonus?.percentages);
    setMinMatch(res?.betting_limits?.minimum_matches);
    setBonusMinimumOdds(res?.betting_limits?.minimum_odds);
    setStake(parseFloat(res.betting_limits.minimum_bet));
    setMinimumBet(parseFloat(res.betting_limits.minimum_bet));
    setMaximumBet(parseFloat(res.betting_limits.maximum_bet));
    setExciseTaxPercentage(parseFloat(res.regulatory.sales_excise_tax));
    setWHTPercentage(parseFloat(res.regulatory.wht_winning_tax));
    setMaximumPayout(res.betting_limits.maximum_payout);
    setMaximumBonusPayout(res.betting_limits.maximum_bonus_payout);
    setFreebetMinimumOdds(res.betting_limits.free_bet_minimum_odds)
    setFreebetMaximumOdds(res.betting_limits.free_bet_maximum_odds)
    setFreebetMinimumMatches(res.betting_limits.free_bet_minimum_matches)
  };
  useEffect(() => {
    if (searchBookingCode != "" && searchBookingCode != null) {
      axiosApi({
        method: "get",
        url: `/client/get-booked-bet/${searchBookingCode}`,
      })
        .then(function (response) {
          if (Array.isArray(response?.data?.data)) {
            dispatch(setBets(response?.data?.data));
            const betDetails = response?.data?.data;

            let BetOdd = betDetails
              .map((bet) => {
                return _getPlacedBet(bet.fixture_markets);
              })
              .map((bet) => {
                let sendBet = {};
                sendBet._id = bet._id;
                return sendBet;
              });

            let bookDetail = {};
            bookDetail.booking_id = searchBookingCode;
            bookDetail.odds = BetOdd;
            localStorage.setItem("book_bet_detail", JSON.stringify(bookDetail));
          } else {
            showMessage("error", response?.data?.data);
          }
        })
        .catch(function (response) { });
    }
  }, [searchBookingCode]);

  useEffect(() => {
    if (Bets.length) {
      let allOdds = Bets?.map((b) =>
        parseFloat(_getPlacedBet(b.fixture_markets).value)
      );
      let is_live = Bets.map((b) => _getPlacedBet(b.fixture_markets).is_live);
      const allEqual = (arr) => arr.every((val) => val == arr[0]);
      const allEqualPrematch = (arr) =>
        arr.every((val) => val == null || val == false);

      setIsAllPrematch(allEqualPrematch(is_live));

      if (!allEqual(is_live)) {
        setcheckLiveSelected(false);
      }
      const betTypeValue = mode === "single" ? 0 : 1;
      let tempTotalOdds = betTypeValue;
      allOdds.forEach((ao) => {
        if (mode === "multiple") {
          tempTotalOdds = tempTotalOdds * ao;
        } else {
          tempTotalOdds += ao;
        }
      });
      setTotalOdds(tempTotalOdds.toFixed(2));
    } else {
      setTotalOdds(0);
    }
  }, [Bets, mode]);

  // Sync shared stake to the sum of per-selection stakes in Single mode (parity with RN)
  useEffect(() => {
    if (mode === "single") {
      const total = Object.values(singleStakes).reduce(
        (a, b) => a + (Number(b) || 0),
        0
      );
      setStake(total);
    }
  }, [singleStakes, mode]);

  useEffect(() => {
    if (bonusPercentage && Bets.length && isAllPrematch == true && !useBonus &&
      !useFreeBet) {
      var betCount = Bets.length;

      let not_applicable_odds = 0;
      let allOdds = Bets.map((b) =>
        parseFloat(_getPlacedBet(b.fixture_markets).value).toFixed(2)
      );

      if (minimumOdds) {
        allOdds.forEach((ao) => {
          if (parseFloat(ao) < parseFloat(minimumOdds)) {
            not_applicable_odds++;
          }
        });
        setNotApplicableOdds(not_applicable_odds);
      }

      var bonus_bet_count =
        parseFloat(betCount) - parseFloat(not_applicable_odds);
      // percentage
      let percentages = JSON.parse(bonusPercentage);

      if (parseFloat(bonus_bet_count) == 0) {
        setSelectedPercent(0);
      } else {
        let selected = Object.values(percentages).find(
          (e) => e.selection === bonus_bet_count
        );
        if (!selected) {
          selected = percentages[percentages.length - 1];
        }
        setSelectedPercent(selected.value);
      }

      let currentUser;
      let groupedMessages = [];

      for (const selection of percentages) {
        if (selection.value !== currentUser) {
          groupedMessages.push([]);
          currentUser = selection.value;
        }
        groupedMessages[groupedMessages.length - 1].push(selection);
      }
      let pills = [];
      groupedMessages.forEach((gp) => {
        let from = gp[0].selection;
        let to = gp[gp.length - 1].selection;
        if (![undefined, null, ""].includes(gp[0].value) && from !== to) {
          pills.push({ from: from, to: to, value: gp[0].value });
        } else if (
          ![undefined, null, ""].includes(gp[0].value) &&
          from === to
        ) {
          pills.push({ from: from, value: gp[0].value });
        }
      });
      let does_go = 0;
      pills.map((item, index) => {
        if (item?.to) {
          if (item.from <= bonus_bet_count && item.to >= bonus_bet_count) {
            does_go = 1;
            if (
              typeof pills[index + 1] != "undefined" &&
              pills[index + 1] !== null
            ) {
              var nextRange = pills[index + 1];
              setAddMoreCount(nextRange.from - bonus_bet_count);
              setBonusPercent(nextRange.value);
            }
          }
        }
      });

      if (does_go == 0) {
        var nextRange = pills[1];
        setAddMoreCount(nextRange.from - bonus_bet_count);
        setBonusPercent(nextRange.value);
      }
      if (pills[pills.length - 1]?.from <= bonus_bet_count) {
        setAddMoreCount(null);
        setBonusPercent(null);
      }
      if (pills[pills.length - 1]?.to <= bonus_bet_count) {
        setAddMoreCount(null);
        setBonusPercent(null);
      }
    } else {
      setAddMoreCount(null);
      setBonusPercent(null);
      setSelectedPercent(0);
      setNotApplicableOdds(0);
    }
  }, [bonusPercentage, Bets, useBonus, useFreeBet, isAllPrematch]);

  const _getPossibleWin = () => {
    let stakeAfterTax = stake - exciseTax;
    // var wht = parseFloat(_getPossibleWHT());
    return (stake * parseFloat(totalOdds) + parseFloat(selectedBonus)).toFixed(
      2
    );
  };

  const _getPossibleWHT = () => {
    let stakeAfterTax = stake - exciseTax;
    let applyTax = stakeAfterTax * totalOdds + parseFloat(selectedBonus);

    let applyPercentWHTOnStakeAfterTax =
      ((applyTax - stakeAfterTax) / 100) * WHTPercentage;

    return applyPercentWHTOnStakeAfterTax.toFixed(2);
  };

  const handleCheckClick = (e) => {
    if (canUseBonus) {
      if (e) {
        setUseBonus(true);
        setOldStake(stake);
        setStake(bonusAmount);
      } else {
        setUseBonus(false);
        setStake(oldStake);
      }
    }
  };

  useEffect(() => {
    setExciseTax((stake / (100 + exciseTaxPercentage)) * exciseTaxPercentage);
  }, [stake, exciseTaxPercentage]);

  useEffect(() => {
    if (Bets.length && isAllPrematch == true) {
      let allOdds = Bets.map((b) =>
        parseFloat(_getPlacedBet(b.fixture_markets).value).toFixed(2)
      );

      let applicable_bet_count = 0;

      if (bonusMinimumOdds == 0) {
        if (Bets.length >= minMatch) {
          setCanUseBonus(true);
        } else {
          setCanUseBonus(false);
        }
      } else if (bonusMinimumOdds) {
        allOdds.forEach((ao) => {
          if (parseFloat(ao) >= parseFloat(bonusMinimumOdds)) {
            applicable_bet_count++;
          }
        });

        if (
          applicable_bet_count == Bets.length &&
          applicable_bet_count >= minMatch
        ) {
          setCanUseBonus(true);
        } else {
          setCanUseBonus(false);
        }
      } else {
        setCanUseBonus(false);
      }

      if (userBalance) {
        if (
          parseFloat(minimumBet) >
          parseFloat(userBalance.replace(`${currency} `, ""))
        ) {
          setCanUseBonus(true);
          setIsBalanceLess(true);
        }
      } else {
        if (parseFloat(minimumBet) > parseFloat(userBalance)) {
          setCanUseBonus(true);
          setIsBalanceLess(true);
        }
      }
    } else {
      setCanUseBonus(false);
    }
    setUseBonus(false);
  }, [bonusMinimumOdds, Bets, isAllPrematch, minMatch]);

  useEffect(() => {
    if (selectedPercent && selectedPercent != 0 && !useBonus) {
      // #% Boost = Stake after tax * TotalOdds - 10% [display the 10% value]
      var stakeAfterTax = (stake - exciseTax).toFixed(2);
      var stakeTax = stakeAfterTax * totalOdds;
      var selectPercent = parseFloat(
        (stakeTax * parseFloat(selectedPercent)) / 100
      );
      setSelectedBonus(selectPercent.toFixed(2));
    } else {
      setSelectedBonus(0);
    }
  }, [selectedPercent, stake, useBonus, totalOdds, exciseTax]);

  const _renderBetslips = (can_use_all = 1) => {
    return Bets.map((betslip) => {
      let marketName = _getMarketName(betslip.fixture_markets);
      let selectedOdd = _getPlacedBet(betslip.fixture_markets);
      let can_go = false;
      let make_it_red = false;
      let selectedOddValue = parseFloat(selectedOdd?.value)?.toFixed(2);

      if (can_use_all) {
        can_go = true;
      } else if (odds) {
        let res = JSON.parse(localStorage.getItem("store_data"));
        if (res) {
          Object.keys(odds).forEach((key) => {
            if (odds[key]["_id"] == selectedOdd._id) {
              if (
                ((!res.is_bonus_used && useBonus) ||
                  (res.bonus_amount &&
                    parseFloat(res.bonus_amount) !=
                    parseFloat(selectedBonus))) &&
                odds[key]["value"] != selectedOdd.value
              ) {
                make_it_red = true;
              }
              can_go = true;
              selectedOddValue = parseFloat(
                odds[getKeyByValue(odds, selectedOdd._id)]["value"]
              )?.toFixed(2);
            }
          });
        }
      }
      const isOff =
        isNaN(parseFloat(selectedOdd?.value)) ||
        selectedOdd?.active === 0 ||
        selectedOdd?.active === "0";
      return (
        <div
          key={betslip._id}
          className="bet-slipitem"
          id="highlightCompletedMatchBet_0"
          data-id={selectedOdd._id}
          style={{ opacity: isOff ? 0.6 : 1 }}
        >
          <div className="bet-slipitem__top">
            <div className="bet-slipitem__pick">
              <span className="bet-slipitem__sel truncate">
                {_renderOddName(betslip, selectedOdd)}
                {selectedOdd?.special_bet_value
                  ? "[" + selectedOdd?.special_bet_value + "]" //Added the special_bet_value from base_line
                  : ""}
              </span>
              <span className="bet-slipitem__mkt">
                {marketName}
                {betslip?.tournament?.name ? ` - ${betslip.tournament.name}` : ""}
              </span>
              <span className="bet-slipitem__ev">
                {betslip?.competitors[0].name ?? "-"} <Trans i18nKey="betslip_vs">vs</Trans>{" "}
                {betslip?.competitors[1]?.name ?? "-"} @{" "}
                <span>
                  {new Date(parseInt(betslip?.match_date.$date.$numberLong)).toLocaleString()}
                </span>
              </span>
            </div>
            <span className="bet-slipitem__price" style={{ color: !can_go || make_it_red ? "red" : undefined }}>
              {isOff ? (
                <span
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: "#ef4444",
                    background: "rgba(239,68,68,0.12)",
                    padding: "2px 6px",
                    borderRadius: 4,
                  }}
                >
                  <Trans i18nKey="betslip_unavailable">Unavailable</Trans>
                </span>
              ) : (
                selectedOddValue
              )}
            </span>
            <button
              type="button"
              className="bet-slipitem__close bet-iconbtn bet-iconbtn--sm"
              aria-label={t("betslip_remove_selection", "Remove selection")}
              style={{ display: !can_use_all ? "none" : undefined }}
              onClick={() => {
                dispatch(setBets(Bets.filter((b) => b._id != betslip._id)));
              }}
            >
              <X size={14} />
            </button>
          </div>
          {mode === "single" && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginTop: 8,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid var(--bet-border)",
                  borderRadius: 6,
                  background: "var(--bet-fore-background)",
                  padding: "4px 8px",
                }}
              >
                <span
                  style={{
                    fontSize: 12,
                    color: "var(--bet-fore-primary)",
                    marginRight: 4,
                  }}
                >
                  {currency}
                </span>
                <input
                  type="number"
                  value={singleStakes[betslip._id] ?? ""}
                  onChange={(e) =>
                    setSingleStakes((prev) => ({
                      ...prev,
                      [betslip._id]: parseFloat(e.target.value) || 0,
                    }))
                  }
                  placeholder="0"
                  style={{
                    width: 70,
                    background: "transparent",
                    border: "none",
                    color: "#fff",
                    fontSize: 13,
                    outline: "none",
                  }}
                />
              </div>
              <div style={{ fontSize: 11, color: "var(--bet-fore-primary)" }}>
                <Trans i18nKey="betslip_returns">Returns</Trans>{" "}
                <span style={{ color: "#fff", fontWeight: 700 }}>
                  {currency}
                  {Math.round(
                    (singleStakes[betslip._id] ?? 0) *
                      (isOff ? 0 : parseFloat(selectedOddValue) || 0)
                  )}
                </span>
              </div>
            </div>
          )}
        </div>
      );
    });
  };

  return (
    <div className="relative bg-[var(--surface-card)] !border !border-[var(--border-subtle)] rounded-[var(--radius-card)] overflow-hidden">
      {/* Title */}
      <div
        className="!border-0 !border-b !border-[var(--border-subtle)]"
        style={{ padding: 12, display: "flex", alignItems: "center", gap: 10 }}
      >
        <span className="text-[var(--text-primary)] font-semibold" style={{ fontSize: 16, lineHeight: 1.2 }}><Trans i18nKey="betslip_title">Betslip</Trans></span>
        {Bets.length > 0 && (
          <span
            data-testid="slip-count"
            style={{
              display: "inline-flex", alignItems: "center", height: 20, padding: "0 8px", borderRadius: 2,
              background: "var(--gold-500)", color: "var(--on-brand)", fontSize: 10, fontWeight: 600, letterSpacing: "0.10em",
            }}
          >
            {Bets.length}
          </span>
        )}
        <div style={{ flex: 1 }} />
        {Bets.length > 0 && (
          <button
            type="button"
            className="bet-iconbtn bet-iconbtn--sm"
            aria-label={t("betslip_clear_all", "Clear All")}
            onClick={() => dispatch(setBets([]))}
          >
            <Trash2 size={16} />
          </button>
        )}
      </div>

      {/* Top Tabs */}
      <div style={{ padding: "12px 12px 0" }}>
        <Tabs value={tab} onValueChange={setTab}>
          <TabsList className="!h-auto !w-fit !gap-2 !rounded-none !bg-transparent !p-0">
            <TabsTrigger
              value="betslip"
              className="!flex !items-center !gap-2 !rounded-full !border !border-[var(--border-subtle)] !px-4 !h-[34px] !py-0 !text-xs !font-bold !uppercase !tracking-[0.10em] !text-[var(--text-secondary)] !bg-[var(--surface-2)] !shadow-none data-[state=active]:!bg-[var(--gold-a20)] data-[state=active]:!border-[var(--border-brand)] data-[state=active]:!text-[var(--gold-300)]"
            >
              <Trans i18nKey="betslip_title">Betslip</Trans>
              <span className="!flex !h-4 !min-w-4 !items-center !justify-center !rounded-full !bg-[var(--surface-3)] !px-1 !text-[11px] !font-bold !text-[var(--text-secondary)]">
                {Bets.length}
              </span>
            </TabsTrigger>
            <TabsTrigger
              value="open bets"
              className="!flex !items-center !gap-2 !rounded-full !border !border-[var(--border-subtle)] !px-4 !h-[34px] !py-0 !text-xs !font-bold !uppercase !tracking-[0.10em] !text-[var(--text-secondary)] !bg-[var(--surface-2)] !shadow-none data-[state=active]:!bg-[var(--gold-a20)] data-[state=active]:!border-[var(--border-brand)] data-[state=active]:!text-[var(--gold-300)]"
            >
              <Trans i18nKey="betslip_open_bets_tab">Open Bets</Trans>
              <span className="!flex !h-4 !min-w-4 !items-center !justify-center !rounded-full !bg-[var(--surface-3)] !px-1 !text-[11px] !font-bold !text-[var(--text-secondary)]">
                {myBetsOpen?.length}
              </span>
            </TabsTrigger>
          </TabsList>
        </Tabs>
      </div>

      {tab === 'betslip' && (
        <>

          {/* Booking code (always shown, as in the design) */}
          <div style={{ padding: "12px 12px 0", display: "flex", flexDirection: "column", gap: 10 }}>
            {Bets.length < 1 && (
              <p className="text-[13px] leading-[1.45] text-[var(--text-secondary)]">
                <Trans i18nKey="betslip_place_bet_instruction">To place a bet click on the odds or insert a booking code</Trans>
              </p>
            )}
            <input
              id="search-booking-id"
              placeholder={t("betslip_booking_code", "Booking Code")}
              aria-label={t("betslip_booking_code", "Booking Code")}
              aria-describedby="basic-addon2"
              maxLength={6}
              value={bookingId}
              onChange={(e) => {
                let value = e.target.value.toUpperCase().trimStart();
                setBookingId(value);
              }}
              className="!w-full !h-[42px] !border !border-[var(--border-default)] bg-[var(--surface-inset)] text-[var(--text-primary)] text-[14px] rounded-[var(--radius-control)] px-3 outline-none"
            />
            <button
              onClick={() => {
                setSearchBookingCode(document.getElementById("search-booking-id").value);
              }}
              className="w-full h-[42px] bg-[var(--surface-3)] hover:bg-[var(--border-strong)] !border !border-[var(--border-default)] text-[var(--text-primary)] rounded-[var(--radius-control)]"
              style={{ fontSize: 13, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.10em" }}
            >
              <Trans i18nKey="betslip_load">Load</Trans>
            </button>
            <p className="text-[var(--text-muted)] text-[11px] leading-[1.45]">
              <Trans i18nKey="betslip_booking_code_helper">A booking code enables one to transfer bet slip between different devices.</Trans>
            </p>
          </div>

          {/* Fold / singles pills */}
          {Bets.length > 1 && (
            <div style={{ padding: "12px 12px 0" }}>
              <Tabs value={mode} onValueChange={setMode}>
                <TabsList className="!h-auto !w-fit !gap-2 !rounded-none !bg-transparent !p-0">
                  <TabsTrigger value="multiple" className="!flex !items-center !gap-2 !rounded-full !border !border-[var(--border-subtle)] !px-4 !h-[34px] !py-0 !text-xs !font-bold !uppercase !tracking-[0.10em] !text-[var(--text-secondary)] !bg-[var(--surface-2)] !shadow-none data-[state=active]:!bg-[var(--gold-a20)] data-[state=active]:!border-[var(--border-brand)] data-[state=active]:!text-[var(--gold-300)]">
                    {Bets.length}-<Trans i18nKey="betslip_fold">fold</Trans>
                  </TabsTrigger>
                  <TabsTrigger value="single" className="!flex !items-center !gap-2 !rounded-full !border !border-[var(--border-subtle)] !px-4 !h-[34px] !py-0 !text-xs !font-bold !uppercase !tracking-[0.10em] !text-[var(--text-secondary)] !bg-[var(--surface-2)] !shadow-none data-[state=active]:!bg-[var(--gold-a20)] data-[state=active]:!border-[var(--border-brand)] data-[state=active]:!text-[var(--gold-300)]">
                    <Trans i18nKey="betslip_mode_singles">Singles</Trans>
                  </TabsTrigger>
                </TabsList>
              </Tabs>
            </div>
          )}

          {Bets.length < 1 && (
            <EmptyState
              icon={Receipt}
              title={t("betslip_empty_title", "Your betslip is empty.")}
              description={t("betslip_empty_description", "Pick an outcome to get started.")}
              className="bg-[image:var(--texture-hatch)] !py-12 !px-6"
            />
          )}

          {Bets.length > 0 && (
            <div style={{ display: "flex", flexDirection: "column", gap: 10, padding: 12, maxHeight: 300, overflowY: "auto" }}>
              {_renderBetslips(1)}
            </div>
          )}
          {Bets.length > 0 && <div style={{ height: 1, background: "var(--border-subtle)" }} />}

          <div className="bg-[var(--surface-card)] text-[var(--text-secondary)] rounded-b-md">
            {Bets.length > 0 && (
              <>
                <div style={{ padding: 12, paddingBottom: 0, display: "flex", flexDirection: "column", gap: 12 }}>
                  <div>
                    <div
                      style={{
                        display: "flex", alignItems: "center", gap: 8, height: 44, padding: "0 12px",
                        background: "var(--surface-inset)", border: "1px solid var(--border-default)", borderRadius: "var(--radius-control)",
                      }}
                    >
                      <span style={{ font: "var(--type-label)", color: "var(--text-muted)", letterSpacing: "var(--ls-wide)" }}>{currency}</span>
                      <input
                        type="number"
                        placeholder={t("betslip_enter_stake", "Enter stake")}
                        disabled={useBonus}
                        min={1}
                        value={stake}
                        onChange={(e) => setStake(e.target.value)}
                        style={{
                          flex: 1, minWidth: 0, background: "none", border: 0, outline: "none", textAlign: "right",
                          color: "var(--text-primary)", fontFamily: "var(--font-numeric)", fontWeight: 700, fontSize: 18,
                          opacity: useBonus ? ".65" : "1", pointerEvents: useBonus ? "none" : "auto",
                        }}
                      />
                    </div>
                    {stake !== "" && Number(stake) < 1 && (
                      <span className="text-red-500 text-xs">
                        <Trans i18nKey="betslip_stake_min_error">Please enter a value not less than 1</Trans>
                      </span>
                    )}
                    <div style={{ display: "flex", gap: 6, marginTop: 8 }}>
                      {[50, 100, 500].map((v) => (
                        <button
                          key={v}
                          type="button"
                          disabled={useBonus}
                          onClick={() => setStake(String((Number(stake) || 0) + v))}
                          style={{
                            flex: 1, height: 30, background: "var(--surface-2)", border: "1px solid var(--border-subtle)",
                            borderRadius: "var(--radius-xs)", color: "var(--text-secondary)", fontWeight: 600, fontSize: 13,
                          }}
                        >
                          +{v}
                        </button>
                      ))}
                    </div>
                  </div>
                  <label style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer", fontSize: 14, color: "var(--text-body)" }}>
                    <input
                      type="checkbox"
                      checked={acceptOddsChange}
                      onChange={(e) => setAcceptOddsChange(e.target.checked)}
                      style={{ width: 18, height: 18, accentColor: "var(--gold-500)", flex: "none" }}
                    />
                    <Trans i18nKey="betslip_accept_odds_changes">Accept odds changes</Trans>
                  </label>
                </div>
                <div className="BLM-stakeBox-container !bg-transparent">
                  {(firstDeposit == 0 || (isBalanceLess && cashLogStatus)) &&
                    Bets.length &&
                    (parseFloat(bonusAmount) > 0 || parseFloat(signupBonus) > 0) &&
                    isBonusActive &&
                    isAllPrematch ? ( //*
                    <div className="BLM-form-group">
                      {bonusAmount && <div className="BLM-checkbox flex items-center justify-end gap-0.5">
                        <button
                          style={{ background: "#d9e1ff", border: "none" }}
                          title={t("betslip_note_min_selection_odds", "Required: Min. selection {minMatch} with {minOdds}+ odds each", { minMatch, minOdds: bonusMinimumOdds })}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="25"
                            viewBox="0 0 137 200"
                            fill="red"
                          >
                            <g id="Layer_2" data-name="Layer 2">
                              <g id="Layer_1-2" data-name="Layer 1">
                                <path
                                  d="M63.36,0c37.1,0,61.88,18.38,61.88,44,0,17.79-10.29,30.24-28.71,39.66C78.8,92.47,73.79,98.52,73.79,110.15v6.75H42.38l-.14-8.26C41,91.43,48.88,81,67.56,71.54,84.35,62.81,90,56.53,90,45,90,32.69,78.66,23.73,61.6,23.73c-17.46,0-28.7,9.19-29.78,23.61H0C1.08,20,23.15,0,63.36,0ZM38.72,155.05c0-9.19,8.8-16.4,19.77-16.4s19.63,7.21,19.63,16.4-8.66,16.52-19.63,16.52S38.72,164.24,38.72,155.05Z"
                                  stroke="#dc3545"
                                />
                              </g>
                            </g>
                          </svg>
                        </button>
                        <input
                          id="navSubMenuCheck1"
                          name
                          defaultValue="check1"
                          type="checkbox"
                          style={{ opacity: !canUseBonus ? ".65" : "1" }}
                          disabled={false}
                          checked={useBonus ? true : false}
                          onChange={(e) => {
                            handleCheckClick(e.target.checked);
                          }}
                        />
                        <label
                          htmlFor="navSubMenuCheck1"
                          style={{ opacity: !canUseBonus ? ".65" : "1" }}
                        />
                        <span
                          className="BLM-checkboxLabel"
                          style={{ opacity: !canUseBonus ? ".65" : "1" }}
                        >
                          <b><Trans i18nKey="betslip_use_bonus_amount">Use Bonus Amount</Trans></b>
                        </span>
                      </div>}
                      {bonusError && (
                        <p className="text-red-500 text-[10px] mt-1">{bonusError}</p>
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="BLM-freeBet" />

                  <div id="displayFreeBetDropDown" />
                </div>
                <div className="BLM-betSlip-footer">
                  {showFreebetMsg == true ? (
                    <div className="BLM-addSelections-infoMsg" id="FreebetMsg">
                      {" "}
                      <a href="" className="text-primary">
                        <Trans i18nKey="betslip_freebet_stake_message">Enter Stake equal to</Trans> {freebet} <Trans i18nKey="betslip_freebet_stake_message_suffix">to use Signup Freebet</Trans>
                      </a>
                    </div>
                  ) : null}

                  {isAllPrematch == false ? (
                    <div className="BLM-addSelections-infoMsg" id="betInfoMsg">
                      {" "}
                      <a href="/" className="text-danger">
                        <Trans i18nKey="betslip_remove_live_matches_for_bonus">Please remove live matches to get Bonus</Trans>
                      </a>
                    </div>
                  ) : addMoreCount && bonusPercent ? (
                    <div
                      id="betInfoMsg"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        margin: "10px 8px 2px",
                        padding: "12px",
                        borderRadius: 8,
                        border: "1px solid #37306D",
                        background: "#1B2140",
                      }}
                    >
                      <div
                        style={{
                          width: 28,
                          height: 28,
                          flexShrink: 0,
                          borderRadius: 14,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          background: "#6B4BFF",
                          marginRight: 10,
                          color: "#fff",
                          fontSize: 18,
                          fontWeight: 800,
                        }}
                      >
                        +
                      </div>
                      <div>
                        <div style={{ color: "#fff", fontSize: 14, fontWeight: 700 }}>
                          <Trans i18nKey="betslip_boost_slip_title">Boost your slip</Trans>
                        </div>
                        <div style={{ color: "#A8B0D0", fontSize: 12, marginTop: 1 }}>
                          {t("betslip_add_more_selections_prefix", "Add")} {addMoreCount}{" "}
                          {addMoreCount === 1
                            ? t("betslip_boost_more_leg_singular", "more leg for")
                            : t("betslip_boost_more_legs_plural", "more legs for")}{" "}
                          <span style={{ color: "var(--bet-header-accent)", fontWeight: 800 }}>
                            +{bonusPercent}% {t("betslip_boost_multi_bonus_suffix", "multi bonus")}
                          </span>
                        </div>
                      </div>
                      {notApplicableOdds > 0 ? (
                        <button
                          style={{ background: "#ebefff", border: "none" }}
                          title={t("betslip_selections_min_value_bonus", "All selections value should be greater than {value} to receive a bonus", { value: minimumOdds })}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-exclamation-circle-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
                          </svg>
                        </button>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                  <div style={{ padding: 12, display: "flex", flexDirection: "column", gap: 12 }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                    <div style={{ display: "flex", alignItems: "baseline", gap: 12 }}>
                      <span style={{ fontSize: 13, color: "var(--text-secondary)" }}><Trans i18nKey="betslip_total_odds_row">Total odds</Trans></span>
                      <span style={{ flex: 1, borderBottom: "1px dotted var(--border-subtle)" }} />
                      <span  style={{ fontWeight: 700, fontSize: 14, color: "var(--text-primary)", fontFamily: "var(--font-numeric)", fontVariantNumeric: "tabular-nums" }}>{formatValue(totalOdds, { type: "number" })}</span>
                    </div>
                    {multiBonusPercent && multiBonusPercent != 0 ? (
                    <div style={{ display: "flex", alignItems: "baseline", gap: 12 }}>
                      <span style={{ fontSize: 13, color: "var(--text-secondary)" }}>{multiBonusPercent}% {t("betslip_boost", "Boost")}</span>
                      <span style={{ flex: 1, borderBottom: "1px dotted var(--border-subtle)" }} />
                      <span  style={{ fontWeight: 700, fontSize: 14, color: "var(--text-primary)", fontFamily: "var(--font-numeric)", fontVariantNumeric: "tabular-nums" }}>{currency} {multiBonusAmount}</span>
                    </div>
                    ) : null}
                    <div style={{ display: "flex", alignItems: "baseline", gap: 12 }}>
                      <span style={{ fontSize: 13, color: "var(--text-secondary)" }}><Trans i18nKey="betslip_stake_label">Stake</Trans></span>
                      <span style={{ flex: 1, borderBottom: "1px dotted var(--border-subtle)" }} />
                      <span  style={{ fontWeight: 700, fontSize: 14, color: "var(--text-primary)", fontFamily: "var(--font-numeric)", fontVariantNumeric: "tabular-nums" }}>{formatValue(Number(stake) || 0, { type: "currency", currency: "NGN" })}</span>
                    </div>
                    <div style={{ display: "flex", alignItems: "baseline", gap: 12 }}>
                      <span style={{ fontSize: 13, color: "var(--text-secondary)" }}><Trans i18nKey="betslip_to_return">To return</Trans></span>
                      <span style={{ flex: 1, borderBottom: "1px dotted var(--border-subtle)" }} />
                      <span id="bindWinningValue" style={{ fontWeight: 700, fontSize: 18, color: "var(--gold-400)", fontFamily: "var(--font-numeric)", fontVariantNumeric: "tabular-nums" }}>{formatValue(_getPossibleWin(), { type: "currency", currency: "NGN" })}</span>
                    </div>
                    </div>
                    <button
                      disabled={Number(stake) < 1}
                      className={clsx(Number(stake) < 1 && "opacity-50 cursor-not-allowed")}
                      onClick={() => {
                        _handleSubmitBet();
                      }}
                      style={{
                        width: "100%", height: 52, border: 0, borderRadius: "var(--radius-control)",
                        background: "var(--gold-500)", color: "var(--on-brand)",
                        fontSize: 14, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.10em", cursor: "pointer",
                      }}
                    >
                      <Trans i18nKey="betslip_place_bet">Place Bet</Trans>
                    </button>
                    <span style={{ fontSize: 12, color: "var(--text-muted)", textAlign: "center" }}>
                      <Trans i18nKey="betslip_responsible_note">18+. Gambling involves risk. Please bet responsibly.</Trans>
                    </span>
                  </div>
                </div>
              </>
            )}
            {Bets.length > 0 && (
              <div className="flex items-center justify-between" style={{ padding: "0 12px 12px", fontSize: 12 }}>
                <button>
                  {loadingBook != null && loadingBook == 1 ? (
                    <span><Trans i18nKey="betslip_generating">Generating</Trans></span>
                  ) : (
                    <span
                      onClick={() => {
                        _handleBookBet();
                      }}
                      className="text-bgray-400"
                    >
                      <Trans i18nKey="betslip_book_bet">Book Bet</Trans>
                    </span>
                  )}
                </button>
                <button>
                  <span className="text-bgray-400"><Trans i18nKey="betslip_print">Print</Trans></span>
                </button>
              </div>
            )}
          </div>
        </>

      )}


      {tab === 'open bets' && (
        <>
          {!isLoggedIn ? (
            <MessageBox data={t("betslip_login_to_view_open_bets", "Please log in to view your open bets.")} />
          ) : (
            <div className="min-h-[150px] p-2">
              {![undefined, null, ''].includes(loadingMessage) &&
                myBetsOpen.length === 0 ? (
                <MessageBox data={loadingMessage} />
              ) : null}
              <OpenBets
                myBets={myBetsOpen}
                isCategory={category == 'Sports' ? true : false}
                category={category}
                setIsCashout={setIsCashout}
                setTicketDetails={setTicketDetails}
                setIsLoadingId={setIsLoadingId}
                isLoadingId={isLoadingId}
                isHome={true}
              />
            </div>
          )}
        </>
      )}
      {
        <div className="row img_row">
          <ReactModal isOpen={openModel} style={customStyles}>
            <div>
              <div>
                <div className="modalHeader "><Trans i18nKey="betslip_confirmation">BetSlip Confirmation</Trans></div>
              </div>
              <div
                className="BLM-betSlip-content"
                style={{ overflowY: "auto", height: "45vh" }}
              >
                <div className="main-slip-st">{_renderBetslips(0)}</div>
              </div>
            </div>
          </ReactModal>
        </div>
      }

      <div className="row img_row">
        <ReactModal isOpen={openBookModel} style={customBetStyles}>
          <div className="modal-content  book-a-bet-div">
            {/* <div className="modal-header">
                                <div className="modal-title h4">SHARE BET</div>
                                <button type="button" className="btn-close btn-close-white" aria-label="Close" onClick={()=> {
                                  setBookModelOpen(false)
                                }}></button>
                              </div> */}
            <div className="modal-body">
              {/* <center><p style={{fontSize:"17px"}}>You can place the booked bet in a betslip or share it with a friend.</p></center> */}

              <div className="code-div">
                <p style={{ fontSize: "17px" }}>
                  <Trans i18nKey="betslip_your_booking_code_is">Booking Code has successfully been generated. Your code is</Trans>
                </p>
                <h4>{bookingId}</h4>

                <p className="copy-code">
                  <a
                    href="javascript:void(0)"
                    style={{ textDecoration: "underline" }}
                    onClick={() => {
                      copied();
                    }}
                  >
                    <Trans i18nKey="betslip_copy_booking_code">COPY BOOKING CODE</Trans>
                  </a>{" "}
                  <span className="apply-p1"></span>
                </p>
                <Whatsapp
                  solid
                  small
                  message={t("betslip_share_message", "Booked Ticket - Great Winnings, just visit Domain and enter Booking Code: {value} on Betslip.", { value: bookingId })}
                  link={bburl}
                />
                <Telegram
                  solid
                  small
                  text={t("betslip_share_message", "Booked Ticket - Great Winnings, just visit Domain and enter Booking Code: {value} on Betslip.", { value: bookingId })}
                  link={bburl}
                />
                <Facebook
                  solid
                  small
                  quote={t("betslip_share_message", "Booked Ticket - Great Winnings, just visit Domain and enter Booking Code: {value} on Betslip.", { value: bookingId })}
                  link={bburl}
                />
                <Twitter
                  solid
                  small
                  message={t("betslip_share_message", "Booked Ticket - Great Winnings, just visit Domain and enter Booking Code: {value} on Betslip.", { value: bookingId })}
                  link={bburl}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary btn-new-bet"
                onClick={(e) => setBookModelOpen(false)}
              >
                <Trans i18nKey="betslip_close">CLOSE</Trans>
              </button>
            </div>
          </div>
        </ReactModal>
      </div>
      {isCashout &&
        <ReactModal
          isOpen={isCashout}
          onRequestClose={() => setIsCashout(false)}
          style={{
            overlay: {
              backgroundColor: "rgba(0,0,0,0.6)",
              backdropFilter: "blur(4px)",
              zIndex: 50,
            },
            content: {
              inset: "50% auto auto 50%",
              transform: "translate(-50%, -50%)",
              background: "transparent",
              border: "none",
              padding: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "visible",
            },
          }}
          ariaHideApp={false}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            className="w-[95%] bg-white rounded-2xl shadow-[0_10px_25px_rgba(0,0,0,0.25)] overflow-hidden"
          >
            {/* HEADER */}
            <div className="flex justify-between items-center border-b px-10 py-4 bg-[var(--bet-header-accent)] text-black">
              <h2 className="text-xl font-extrabold tracking-tight"><Trans i18nKey="betslip_cashout_offer">Cashout Offer</Trans></h2>
              <button
                onClick={() => setIsCashout(false)}
                className="p-1 hover:bg-black/10 rounded-full transition"
              >
                <X size={22} />
              </button>
            </div>

            {/* BODY */}
            <div className="p-6 px-10 text-center">
              {/* Potential Win */}
              <div className="mb-2 md:mb-5">
                <p className="text-sm text-black font-medium"><Trans i18nKey="betslip_your_potential_winnings">Your Potential Winnings</Trans></p>
                <p className="text-xl font-bold text-black mt-1">
                  ₦
                  {ticketDetails?.ticket?.to_win?.toLocaleString("en-NG", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </p>
              </div>

              {/* Cashout Value */}
              <motion.div
                key={ticketDetails?.cashout_amount}
                initial={{ scale: 1 }}
                animate={{ scale: [1, 1.08, 1] }}
                transition={{ duration: 0.4 }}
                className="bg-[#18191B] py-3 md:py-5 px-4 rounded-xl shadow-inner"
              >
                <p className="text-sm text-white mb-1 font-semibold"><Trans i18nKey="betslip_available_cashout">Available Cashout</Trans></p>
                <p className="text-5xl font-extrabold text-[var(--bet-header-accent)] drop-shadow-sm">
                  ₦
                  {ticketDetails?.cashout_amount?.toLocaleString("en-NG", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </p>
              </motion.div>


              {/* Divider */}
              <div className="border-t mt-3 md:mt-6 mb-2 md:mb-4"></div>

              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row gap-3">
                <button
                  onClick={() => {

                    setConfirmCashoutLoading(true)
                    confirmCashout({ ticket_id: ticketDetails?.ticket_id })
                      .then((res) => {
                        setIsCashout(false);
                        showMessage(
                          "success",
                          res?.data?.message ?? t("betslip_cashout_success", "Cashout successful")
                        );
                        getMyBetsData(category, active_tab, successGetMyBets, errorGetMyBets, sortCategory);
                      })
                      .catch((e) => {
                        console.log("Fetch error:", e);
                      }).finally(() => { setConfirmCashoutLoading(false); })
                  }
                  }
                  disabled={confirmCashoutLoading}
                  className="flex-1 bg-[var(--bet-header-accent)] hover:bg-yellow-300 text-black !text-lg font-bold py-3 rounded-xl transition flex items-center justify-center gap-2 shadow-md hover:shadow-lg"
                >
                  {confirmCashoutLoading ? (
                    <>
                      <Loader2 className="animate-spin w-4 h-4" /> <Trans i18nKey="betslip_processing">Processing...</Trans>
                    </>
                  ) : (
                    t("betslip_confirm_cashout", "Confirm Cashout")
                  )}
                </button>

                <button
                  onClick={() => setIsCashout(false)}
                  className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold !text-lg py-3 rounded-xl transition shadow-sm"
                >
                  <Trans i18nKey="betslip_cancel">Cancel</Trans>
                </button>
              </div>
            </div>
          </motion.div>
        </ReactModal>

      }
    </div>

  );
};

export default BetSlipWidget;
